<template>
  <v-card id="inviteBuyerForm">
    <div v-if="!isMobile" class="invite-buyer-form__title">
      Invite Client
    </div>
    <v-icon v-if="!isMobile" class="invite-buyer-form__close" @click.stop="closeModal()">
      close
    </v-icon>
    <v-icon class="invite-buyer-form__icon">
      how_to_reg
    </v-icon>
    <div style="width: 70%; margin: 0 auto;">
      Please enter new user's details and send
      invitation to add them to your client's list
    </div>
    <v-card-text>
      <v-form id="inviteForm" ref="inviteForm" lazy-validation>
        <v-text-field
          v-model="buyerName"
          class="inviteForm__input-field"
          placeholder="Name*"
          :rules="nameRules"
          single-line
        />
        <v-text-field
          v-model="buyerPhone"
          class="inviteForm__input-field"
          placeholder="Phone*"
          :rules="phoneRules"
          single-line
          mask="phone"
        />
        <v-text-field
          v-model="buyerEmail"
          class="inviteForm__input-field"
          placeholder="Email*"
          :rules="emailRules"
          single-line
        />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn
        id="sendInvitationButton"
        :disabled="authStatus.loading"
        @click.stop="handleInviteFormSubmit"
      >
        send invitation
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import { inviteSingleClient } from '../../../services/invite-service'

const emailRules = [
  v => !!v || 'E-mail is required',
  v =>
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      v
    ) || 'E-mail must be valid'
]

export default {
  data: () => ({
    buyerName: null,
    buyerPhone: null,
    buyerEmail: null,
    nameRules: [
      v => !!v || 'Name is required',
      v => (v && v.length > 2) || 'Name must be at least 3 characters'
    ],
    emailRules,
    phoneRules: [
      v => !!v || 'Phone is required',
      v => (v && v.length > 9) || 'Phone number should be at least 10 digits'
    ],
    authStatus: {
      loading: false
    }
  }),

  computed: {
    ...mapState('agent', ['agentData']),
    ...mapState('common', ['isMobile']),
    ...mapState('style', ['modal'])
  },

  methods: {
    async handleInviteFormSubmit() {
      if (this.$refs.inviteForm.validate()) {
        this.authStatus.loading = true
        const inviteBuyerPayload = {
          name: this.buyerName,
          phone: this.buyerPhone,
          email: this.buyerEmail
        }

        if (this.agentData) {
          const clientExist = this.agentData.clients.some(
            client => client.email === this.buyerEmail
          )

          if (!clientExist) {
            const response = await inviteSingleClient(inviteBuyerPayload)
            this.authStatus.loading = false
            if (response.status === 200) {
              this.closeModal(true, 'You have successfully invited a user')
            } else {
              this.closeModal(
                true,
                'Validation error regarding the input fields. Please try invitation again.'
              )
            }
          } else {
            this.closeModal(
              true,
              `The client with email id ${this.buyerEmail} already exists`
            )
          }
        }
      }
    },

    closeModal(showMessage = false, message = null) {
      this.$refs.inviteForm.reset()
      this.$emit('on-modal-close', { showMessage, message })
    }
  }
}
</script>

<style lang="sass" scoped>
#inviteBuyerForm
  @extend %card_mobile
  @extend %modal

.invite-buyer-form__close
  @extend %modal__button-close, %disable-selection

.invite-buyer-form__title
  @extend %modal__title

.invite-buyer-form__icon
  border-top-left-radius: 50%!important
  border-top-right-radius: 50%!important
  @extend %modal__icon

.inviteForm__input-field
  @extend %modal__text-field

.inviteForm__input-field  .v-input__slot:before
  border: none

#sendInvitationButton
  @extend %modal__button
  background-color: $hwayzBrandGold !important

</style>
